import React from 'react';
interface CardProps {
  title?: string;
  children: ReactNode;
  className?: string;
}
export const Card: React.FC<CardProps> = ({
  title,
  children,
  className = ''
}) => {
  return <div className={`bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow duration-300 ${className}`} data-id="element-68">
      {title && <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between" data-id="element-69">
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-70">{title}</h3>
        </div>}
      <div className="p-5" data-id="element-71">{children}</div>
    </div>;
};